import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext.js';

interface ProtectedRouteProps {
  children: React.ReactElement;
  roles?: string[];
}

export function ProtectedRoute({ children, roles }: ProtectedRouteProps): React.ReactElement {
  const { isAuthenticated, isLoading, isReconnecting, user, refreshUser } = useAuth();
  const location = useLocation();
  const [verified, setVerified] = useState(false);

  useEffect(() => {
    if (roles && roles.length > 0 && isAuthenticated) {
      void refreshUser().then(() => setVerified(true));
    } else {
      setVerified(true);
    }
  }, [location.pathname]);

  if (isLoading || !verified) {
    if (isReconnecting) {
      return (
        <div className="auth-loading auth-loading--reconnecting">
          <p>Reconnecting to server...</p>
        </div>
      );
    }
    return <div className="auth-loading" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (roles && roles.length > 0 && user) {
    const allUserRoles: string[] = [...(user.role ? [user.role] : []), ...(user.roles ?? [])];
    if (!roles.some((r) => allUserRoles.includes(r))) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
}
